export default __webpack_public_path__ + "static/media/remove-teacher.685ef475.png";